import createDate from './options/create-date';
import approvalType from './options/approval-type';
import returnExchangeType from './options/return-exchange-type';
import refundMethod from './options/refund-method';
import fulfillmentStatuses from './options/fulfillmentStatuses';
import amount from './options/amount';

// Export filter groups
export const popularFilterByOptions = [approvalType, returnExchangeType, refundMethod, createDate, fulfillmentStatuses, amount];
